module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 73.61379e95.png";